import Swiper from "swiper/swiper-bundle.mjs";

// Swup replaces the DOM on each transition, so instances must be
// destroyed and re-created (with freshly queried elements) every time.
let carousel = null;
let galleryThumbs = null;
let galleryMain = null;

const destroySwiper = () => {
  if (carousel) {
    carousel.destroy(true, true);
    carousel = null;
  }

  if (galleryMain) {
    galleryMain.destroy(true, true);
    galleryMain = null;
  }

  if (galleryThumbs) {
    galleryThumbs.destroy(true, true);
    galleryThumbs = null;
  }
};

const initSwiper = () => {
  destroySwiper();

  const carouselEl = document.querySelector(".carousel");
  const galleryThumbsEl = document.querySelector(".gallery-thumbs");
  const galleryMainEl = document.querySelector(".gallery");

  if (carouselEl) {
    carousel = new Swiper(carouselEl, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        type: "dots",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  if (galleryThumbsEl) {
    galleryThumbs = new Swiper(galleryThumbsEl, {
      spaceBetween: 12,
      slidesPerView: 6,
      freeMode: true,
      watchSlidesProgress: true,
    });
  }

  if (galleryMainEl) {
    galleryMain = new Swiper(galleryMainEl, {
      spaceBetween: 12,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });

    const updateActiveThumb = () => {
      if (!galleryThumbs) {
        return;
      }

      galleryThumbs.slides.forEach((slide) => {
        slide.classList.remove("border-blue");
      });

      galleryThumbs.slides[galleryMain.activeIndex]?.classList.add(
        "border-blue",
      );
    };

    galleryMain.on("slideChange", updateActiveThumb);
    updateActiveThumb();

    const variantButtons = document.querySelectorAll('button[id^="variant-"]');

    // Function to set the active variant button based on the currently active slide.
    const setActiveVariant = (activeButton) => {
      variantButtons.forEach((variantButton) => {
        const isActive = variantButton === activeButton;
        variantButton.classList.toggle("bg-blue", isActive);
        variantButton.classList.toggle("text-white", isActive);
        variantButton.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    };

    // Each variant's slides are prefixed with its button id, e.g. "variant-x-1".
    const updateActiveVariant = () => {
      const currentSlide = galleryMain.slides[galleryMain.activeIndex];

      if (!currentSlide) {
        return;
      }

      const activeButton = Array.from(variantButtons).find((variantButton) =>
        currentSlide.id.startsWith(`${variantButton.id}-`),
      );

      if (activeButton) {
        setActiveVariant(activeButton);
      }
    };

    galleryMain.on("slideChange", updateActiveVariant);
    updateActiveVariant();

    // Handle variant button clicks to navigate to the corresponding slide and set the active variant.
    variantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const firstImage = document.getElementById(`${button.id}-1`);
        const slideIndex = galleryMain.slides.indexOf(firstImage);

        if (slideIndex >= 0) {
          galleryMain.slideTo(slideIndex);
        }

        setActiveVariant(button);
      });
    });
  }
};

export default initSwiper;
